<template>
	<div class="earnest page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
	</div>
</template>

<script>
	export default {
		name: 'earnest',
		data() {
			return {
				id: '',
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-refresh-left',
					word: '全部释放',
					sign: 'release'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'memberId',
							label: '缴纳人',
							width: 280
						},
						{
							prop: 'lotName',
							label: '拍品名称',
							width: 300
						},
						{
							prop: 'biddingNo',
							label: '竞买号',
							width: 280
						},
						{
							prop: 'bondPrice',
							label: '缴纳金额',
							width: 100
						},
						{
							prop: 'payTime',
							label: '缴纳时间',
							width: 170
						},
						{
							prop: 'zfStatus',
							label: '当前状态',
							width: 100,
							template: true
						},
						{
							prop: 'returnTime',
							label: '释放时间',
							width: 170
						}
					],
					tableEvent: [
						// {
						// 	icon: 'el-icon-delete',
						// 	name: '删除',
						// 	color: 'red',
						// 	sign: 'delete'
						// },
						{
							icon: 'el-icon-delete',
							name: '释放',
							color: 'blue',
							sign: 'release'
						}
					],
					emptyDescription: '当前没有数据',
				},
				tableData: []
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData()
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'release') {
					this.$api.auctionGoodsReleaseAll({
						id: this.id
					},res=>{
						if(res.code==200){
							this.fetchData()
							this.$message({
								message: '保证金全部释放成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}
			},
			// 筛选条件变化
			filterChange() {
				console.log(this.filterValue);
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				if (sign == 'release') {
					if(row.zfStatus == 0){
						this.$message.error('未支付不可释放')
						return
					}
					if(row.zfStatus == 2){
						this.$message.error('保证金已释放')
						return
					}
					if(row.zfStatus == 3){
						this.$message.error('保证金已扣除')
						return
					}
					this.$api.auctionGoodsRelease({
						bondId: row.bondId
					}, res => {
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: '保证金释放成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}
				// if (sign == 'delete') {

				// }
			},
			fetchData() {
				this.$api.auctionGoodsEarnest({
					id: this.id,
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						let data = res.data.list
						for (let i = 0; i < data.length; i++) {
							data[i]['zfStatus'] = data[i]['payStatus']
						}
						this.tableData = data
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped"></style>
